module.exports = __webpack_public_path__ + "static/media/20240811_113450.14ac3dd5.jpg";